module.exports = __webpack_public_path__ + "media/images/logos/AstroAwani-logo-b4291ac2b920217b91c1067359b908d0.png";